import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

export interface DropdownOption {
  label: string;
  value: any;
}

@Component({
  selector: 'ks-custom-dropdown',
  standalone: false,
  templateUrl: './custom-dropdown.component.html',
  styleUrl: './custom-dropdown.component.scss',
})
export class CustomDropdownComponent {
  @Input() label: string = '';
  @Input() options: DropdownOption[] = [];
  @Input() value: any = null;
  @Input() placeholder: string = 'Select';

  @Output() valueChange = new EventEmitter<any>();
  @Output() selectionChange = new EventEmitter<any>();

  isOpen = false;

  constructor(private elementRef: ElementRef) {}

  get selectedOptionLabel(): string {
    const selected = this.options.find(opt => opt.value === this.value);
    return selected ? selected.label : this.placeholder;
  }

  /**
   * The click is deliberately allowed to bubble: every dropdown closes itself
   * from a `document:click`, so stopping it here would leave any other open
   * dropdown open behind this one.
   */
  toggleOpen(): void {
    this.isOpen = !this.isOpen;
  }

  selectOption(val: any): void {
    this.value = val;
    this.valueChange.emit(val);
    this.selectionChange.emit(val);
    this.isOpen = false;
  }

  /** Closes on Escape, so the menu is not a keyboard trap. */
  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
}
